skrilla.directive('affiliatePromotionClaims',function() {
    return {
        templateUrl: 'directives/promotionClaims/affiliatePromotionClaims.html',
        scope: {
            affiliate: "="
        },
        controller: function($scope, searchService, queryService, paginationService, cacheService, modalService){
            $scope.selectedClaims = [];
            $scope.key = "affiliateClaims";
            $scope.reset = function() {
                $scope.query = {
                    ownerId: $scope.affiliate.id,
                    limit: 20
                }
            }
            $scope.reset();

            $scope.paidStatuses = [
                "PENDING",
                "PAID",
                "DECLINED"
            ]


            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getClaims, $scope.key);
            }

            var getClaims = function () {
                return searchService.get("promotions/claims" + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.claims = response.data.result;
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.clicked = function(claim){
                if(claim.selected === false || claim.selected === undefined) {
                    $scope.selectedClaims.push(claim);
                }
                else{
                    $scope.selectedClaims = $scope.selectedClaims.filter(function(_claim){return _claim.id !== claim.id});
                }
                cacheService.registerObject("selectedAffiliateClaims", $scope.selectedClaims);
            }

            $scope.reconcile = function(){
                cacheService.registerObject("affiliateAddress", $scope.affiliate.ethereumAddress);
                modalService.openModal("views/reconcileAffiliateClaims/reconcileAffiliateClaims.html", true, 'lg', true, true, function(){
                    $scope.selectedClaims = [];
                    $scope.search();
                });
            }

        }
    };
});
